var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{ref:"apex",attrs:{"id":"primary-data-row","height":"350px","options":_vm.chartOptions,"series":_vm.chartSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }